import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecureImagePipe } from './secure-image/secure-image.pipe';

@NgModule({
  declarations: [SecureImagePipe],
  exports: [SecureImagePipe]
})
export class PipesModule {}